'use client';

import { PropsWithChildren } from 'react';
import { Box, Stack } from '@/primitives';
import { usePathname } from 'next/navigation';
import {
  FOOTER_HEIGHT,
  MOBILE_FOOTER_HEIGHT,
  NAV_HEIGHT,
} from '@/configs/layout';

export default function SocietyPublicSearchLayout({
  children,
}: PropsWithChildren) {
  const pathname = usePathname();
  const isMemberDetail = /\/members\/.+/.test(pathname);
  const isAnimalDetail =
    /\/animals\/.+/.test(pathname) &&
    !/\/animals\/(mating|ebv-percentages)(\/|$)/.test(pathname);
  const isEntityDetailPage = isMemberDetail || isAnimalDetail;

  return (
    <Stack
      direction="column"
      sx={{
        flex: 1,
        gap: { xs: '6px', md: '12px' },
        px: { xs: isEntityDetailPage ? '12px' : '20px', md: '20px' },
        pt: { xs: '2px', md: '3px' },
        pb: 0,
        bgcolor: isEntityDetailPage ? 'background.paper' : 'background.default',
        minHeight: 0,
        maxHeight: {
          xs: `calc(100vh - ${NAV_HEIGHT}px - ${MOBILE_FOOTER_HEIGHT}px)`,
          md: `calc(100vh - ${NAV_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
        },
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Stack>
  );
}
